import * as React from 'react';
import { Dialog } from '../Dialog';
import { ShareButtons } from './ShareButtons';
import { ShareUrl } from './ShareUrl';
import './style.css';

export interface ShareDialogProps {
  /* empty */
  url: string;
  title: string;
  onClose: () => void;
}

export interface ShareDialogState {
  /* empty */
}

export class ShareDialog extends React.Component<
  ShareDialogProps,
  ShareDialogState
> {
  render() {
    const { children, onClose, url } = this.props;
    const absoluteUrl = this.toAbsoluteUrl(url);

    return (
      <Dialog
        dialogClassName="share-dialog"
        title={'Share this video to social media & friends'}
        onClose={onClose}
      >
        {children}
        <ShareButtons {...this.props} url={absoluteUrl} />
        <ShareUrl url={absoluteUrl} />
      </Dialog>
    );
  }

  private toAbsoluteUrl = (url: string): string => {
    const { host, protocol } = window.location;
    return `${protocol}//${host}${url}`;
  };
}

export default ShareDialog;



// WEBPACK FOOTER //
// ./src/app/components/Common/ShareDialog/index.tsx